import React from 'react';
import { Footer } from '../components/layout/Footer';
import { Header } from '../components/layout/Header';
import { MobileActionBar } from '../components/layout/MobileActionBar';
import { AnswerNeeds } from '../components/sections/AnswerNeeds';
import { Faq } from '../components/sections/Faq';
import { FinalLead } from '../components/sections/FinalLead';
import { GoogleReviews } from '../components/sections/GoogleReviews';
import { Hero } from '../components/sections/Hero';
import { PlannerPack } from '../components/sections/PlannerPack';
import { Process } from '../components/sections/Process';
import { QuoteForm } from '../components/sections/QuoteForm';
import { SecondaryServices } from '../components/sections/SecondaryServices';
import { ShutterOptions } from '../components/sections/ShutterOptions';
import { TestimonialsWhy } from '../components/sections/TestimonialsWhy';
import { WorkGallery } from '../components/sections/WorkGallery';
export function Home() {
  return <div className="min-h-screen w-full bg-neutral-canvas" data-id="element-571" data-mp="30xb71x5voltk">
      <Header data-id="element-572" data-mp="30uozhxizm6bc" />
      <main data-id="element-573" data-mp="2vxou7otyp7la">
        <Hero data-id="element-574" data-mp="2vxydktki4gi0" />
        <GoogleReviews data-id="element-575" data-mp="2vxf503gqr4gn" />
        <WorkGallery data-id="element-576" data-mp="2vy836g1mwln6" />
        <AnswerNeeds data-id="element-577" data-mp="2vvlta9r9tu1s" />
        <TestimonialsWhy data-id="element-578" data-mp="2qybxmcdagm5i" />
        <ShutterOptions data-id="element-579" data-mp="2qxu1rgujg9y4" />
        <Process data-id="element-580" data-mp="2qx0vegzhrmgi" />
        <Faq data-id="element-581" data-mp="2r0ondbpag0t4" />
        <QuoteForm data-id="element-582" data-mp="2mx0hcxgb1d9z" />
        <PlannerPack data-id="element-583" data-mp="2mxjn7fsokb7n" />
        <SecondaryServices data-id="element-584" data-mp="2mvyvdxxr36dh" />
        <FinalLead data-id="element-585" data-mp="2mwqrd9v9f64a" />
      </main>
      <Footer data-id="element-586" data-mp="2hxnj7gjzgjs3" />
      <MobileActionBar data-id="element-587" data-mp="2hyfcgkq3y5f7" />
    </div>;
}